/**
 * « Maintenant » sur sa page, ou dans l'angle Maintenant d'une feuille (chantier
 * angles-du-projet, ticket 02). C'est le même écran (`Maintenant.tsx`), jamais une copie : dans
 * l'angle, la portée est la bulle ouverte, et ce qui ne parle que de la page s'efface.
 *
 * Dans l'angle : ni la tête (le titre, « Ma journée », le menu des projets, « Plan de vie ») ni
 * les bandeaux de la journée, qui parlent de tous les projets ; pas l'accueil sans projet (une
 * feuille ouverte en est un) ; rien n'est dit au tuto, dont les parties sur « Maintenant »
 * suivent la page. Les réglages restent, les mêmes que ceux de la page.
 */
export interface PartiesDeMaintenant {
  /** Le titre de la page, et ce qui se range à côté. */
  tete: boolean;
  /** Le menu « Tous les projets ». */
  choixDuProjet: boolean;
  /** Le lien « Ma journée » et « Plan de vie ». */
  maJournee: boolean;
  /** Les bandeaux de la veille et du lendemain. */
  bandeaux: boolean;
  /** « Par quoi tu commences ? », sans projet à soi. */
  premier: boolean;
  /** « J'ai », « Je suis », « Courage », en ligne (au téléphone, ils passent par son panneau). */
  reglages: boolean;
  /** Ce que la page montre, dit au tuto. */
  signaleAuTuto: boolean;
}

export function partiesDeMaintenant({ dansUnAngle, auPouce }: { dansUnAngle: boolean; auPouce: boolean }): PartiesDeMaintenant {
  const surLaPage = !dansUnAngle;
  return {
    tete: surLaPage,
    choixDuProjet: surLaPage && !auPouce,
    maJournee: surLaPage && !auPouce,
    bandeaux: surLaPage && !auPouce,
    premier: surLaPage,
    reglages: !auPouce,
    signaleAuTuto: surLaPage,
  };
}

/** La portée demandée au serveur : dans un angle, la bulle ouverte ; sur la page, le projet choisi, ou tous. */
export function porteeDeMaintenant(angle: string | null, projetChoisi: string | null): string | null {
  return angle ?? projetChoisi;
}
